import { SCHEMAS, SCHEMA_IDS, type SchemaId } from "@/lib/schemas";
import { cn } from "@/lib/utils";

interface SchemaPickerProps {
  value: SchemaId;
  onChange: (schema: SchemaId) => void;
}

export function SchemaPicker({ value, onChange }: SchemaPickerProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
      {SCHEMA_IDS.map((id) => {
        const schema = SCHEMAS[id];
        const selected = id === value;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            className={cn(
              "rounded-lg border-2 p-3 text-left transition-all",
              "hover:border-brand hover:bg-brand-50/40",
              selected ? "border-brand bg-brand-50 ring-2 ring-brand/20" : "border-neutral-200 bg-white",
            )}
          >
            <div className="text-2xl mb-1" aria-hidden>{schema.icon}</div>
            <div className="font-medium text-sm text-neutral-900">{schema.label}</div>
          </button>
        );
      })}
    </div>
  );
}
